module.exports = __webpack_public_path__ + "img/SBA.882446bd.png";